import { useState, useEffect } from 'react';
import { OriginalsNav } from '@/components/OriginalsNav';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OriginalsAbout() {
  const [aboutImage, setAboutImage] = useState('');
  const [aboutText, setAboutText] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API}/site-settings`);
        setAboutImage(res.data.originals_about_image || '');
        setAboutText(res.data.originals_about_text || '');
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0a]">
        <OriginalsNav />
        <div className="pt-28 flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-[#d4af37] border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  const hasContent = aboutImage || aboutText;

  return (
    <div className="min-h-screen bg-[#0a0a0a]" data-testid="originals-about">
      <OriginalsNav />

      <div className="pt-28 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <h1 className="font-playfair text-4xl sm:text-5xl text-white mb-12 opacity-0 animate-slide-up" style={{ animationFillMode: 'forwards' }}>
            About
          </h1>

          {hasContent ? (
            <div className="space-y-10 opacity-0 animate-slide-up animation-delay-200" style={{ animationFillMode: 'forwards' }}>
              {aboutImage && (
                <div className="rounded-lg overflow-hidden">
                  <img
                    src={aboutImage}
                    alt="About Ben Jefferies Originals"
                    className="w-full max-h-[500px] object-cover"
                    data-testid="about-image"
                  />
                </div>
              )}

              {aboutText && (
                <div className="space-y-4" data-testid="about-text">
                  {aboutText.split('\n').filter(p => p.trim()).map((paragraph, i) => (
                    <p key={`about-${paragraph.slice(0, 20)}-${i}`} className="font-cormorant text-lg lg:text-xl text-[#a1a1aa] leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <p className="font-cormorant text-lg text-[#a1a1aa]">
              About content coming soon.
            </p>
          )}
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-[#27272a] py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-cormorant text-sm text-[#a1a1aa]">
              &copy; 2024 Ben Jefferies Originals. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/originals" className="font-cormorant text-sm text-[#a1a1aa] hover:text-[#d4af37]">Gallery</Link>
              <Link to="/originals/about" className="font-cormorant text-sm text-[#d4af37]">About</Link>
              <Link to="/engineering" className="font-cormorant text-sm text-[#a1a1aa] hover:text-[#d4af37]">BJ Engineering</Link>
              <Link to="/engineering/contact" className="font-cormorant text-sm text-[#a1a1aa] hover:text-[#d4af37]">Contact</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
